import { render, staticRenderFns } from "./ProviderResult.vue?vue&type=template&id=48eb951e&"
import script from "./ProviderResult.vue?vue&type=script&lang=js&"
export * from "./ProviderResult.vue?vue&type=script&lang=js&"
import style1 from "@/vendor/libs/vue-jstree/vue-jstree.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports